import { useMemo } from "react";
import { Helmet } from "react-helmet-async";
import { CheckCircle, Sparkles } from "lucide-react";

export default function Consultations() {
  // const location = useLocation();
  // const [selectedDate, setSelectedDate] = useState("");
  // const [selectedTime, setSelectedTime] = useState("");
  // const [fullName, setFullName] = useState("");
  // const [email, setEmail] = useState("");
  // const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);
  // const timeSlotsRef = useRef(null);
  // const infoSectionRef = useRef(null);
  // const bookingSectionRef = useRef(null);
  // const [viewMonth, setViewMonth] = useState(() => {
  //   const now = new Date();
  //   return new Date(now.getFullYear(), now.getMonth(), 1);
  // });

  // const today = useMemo(() => {
  //   const now = new Date();
  //   return new Date(now.getFullYear(), now.getMonth(), now.getDate());
  // }, []);

  const pricingOptions = useMemo(
    () => [
      {
        title: "Discovery Call",
        price: "Free",
        duration: "20 min",
        description: "A quick call to discuss goals and see if we’re a fit.",
        highlight: true,
      },
      {
        title: "Initial Consultation",
        price: "£150",
        duration: "90 min",
        description: "Deep dive into health history with tailored next steps.",
      },
      {
        title: "Follow-Up Consultation",
        price: "£100",
        duration: "45 min",
        description: "Progress review and plan refinements.",
      },
      {
        title: "Package 1 (initial + 2 follow-up)",
        price: "£300",
        description: "Diet review with focused improvements.",
      },
      {
        title: "Package 2 (initial + 5 follow-up)",
        price: "£550",
        description: "Fuel strategy for energy, focus, and recovery.",
      },
      {
        title: "Maintenance Consultation",
        price: "£75",
        description: "Best value for building sustainable change.",
      },
    ],
    [],
  );

  // const timeSlots = useMemo(
  //   () => ["09:00", "10:30", "12:00", "14:00", "15:30", "17:00"],
  //   [],
  // );

  // const calendarDays = useMemo(() => {
  //   const firstDay = new Date(viewMonth.getFullYear(), viewMonth.getMonth(), 1);
  //   const startIndex = (firstDay.getDay() + 6) % 7;
  //   const startDate = new Date(firstDay);
  //   startDate.setDate(firstDay.getDate() - startIndex);

  //   return Array.from({ length: 42 }, (_, index) => {
  //     const date = new Date(startDate);
  //     date.setDate(startDate.getDate() + index);
  //     return date;
  //   });
  // }, [viewMonth]);

  // const formatDisplayDate = (isoDate) => {
  //   if (!isoDate) return "";
  //   const [year, month, day] = isoDate.split("-");
  //   return `${day}.${month}.${year}`;
  // };

  // const handleSelectDate = (date) => {
  //   const isoDate = `${date.getFullYear()}-${String(
  //     date.getMonth() + 1,
  //   ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
  //   setSelectedDate(isoDate);
  //   setSelectedTime("");
  // };

  // useEffect(() => {
  //   if (selectedDate && timeSlotsRef.current) {
  //     timeSlotsRef.current.scrollIntoView({
  //       behavior: "smooth",
  //       block: "start",
  //     });
  //   }
  // }, [selectedDate]);

  // useEffect(() => {
  //   if (selectedDate && selectedTime && infoSectionRef.current) {
  //     infoSectionRef.current.scrollIntoView({
  //       behavior: "smooth",
  //       block: "start",
  //     });
  //   }
  // }, [selectedDate, selectedTime]);

  // useEffect(() => {
  //   if (location.state?.scrollToBooking && bookingSectionRef.current) {
  //     setTimeout(() => {
  //       bookingSectionRef.current.scrollIntoView({ behavior: "smooth" });
  //     }, 100);
  //   }
  // }, [location]);
  // const [submissionStatus, setSubmissionStatus] = useState("");
  // const formRef = useRef(null);
  // const onSubmit = async (event) => {
  //   event.preventDefault();
  //   const formData = new FormData(event.target);
  //   formData.append("access_key", "d70cbf89-f564-4524-a61b-ea02fba668cf");
  //   formData.append("Selected date", formatDisplayDate(selectedDate));
  //   formData.append("Selected time", selectedTime);
  //   formData.append("Service", "Discovery Call");

  //   try {
  //     const response = await fetch("https://api.web3forms.com/submit", {
  //       method: "POST",
  //       body: formData,
  //     });

  //     const data = await response.json();
  //     if (data.success) {
  //       setSubmissionStatus("success");
  //       setIsStatusModalOpen(true);
  //       setFullName("");
  //       setEmail("");
  //       setSelectedDate("");
  //       setSelectedTime("");
  //       formRef.current?.reset();

  //       setTimeout(() => {
  //         setSubmissionStatus("");
  //         setIsStatusModalOpen(false);
  //       }, 3000);
  //     } else {
  //       setSubmissionStatus("error");
  //       setIsStatusModalOpen(true);
  //       setTimeout(() => {
  //         setSubmissionStatus("");
  //         setIsStatusModalOpen(false);
  //       }, 3000);
  //     }
  //     console.log(data);
  //   } catch (error) {
  //     setSubmissionStatus("error");
  //     setIsStatusModalOpen(true);
  //     setTimeout(() => {
  //       setSubmissionStatus("");
  //       setIsStatusModalOpen(false);
  //     }, 3000);
  //   }
  // };

  return (
    <div className="min-h-screen bg-gradient-to-b bg-primary to-green-400/10">
      {/* {isStatusModalOpen && submissionStatus && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
          role="dialog"
          aria-modal="true"
          aria-live="polite"
        >
          <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-2xl">
            <div className="flex items-start justify-between gap-4">
              <div>
                <h3 className="text-lg font-semibold text-gray-900">
                  {submissionStatus === "success"
                    ? "Booking request sent"
                    : "Submission failed"}
                </h3>
                <p className="mt-2 text-sm text-gray-600">
                  {submissionStatus === "success"
                    ? "Thanks! We’ll get back to you shortly to confirm your booking."
                    : "Something went wrong. Please try again."}
                </p>
              </div>
              <button
                type="button"
                onClick={() => setIsStatusModalOpen(false)}
                className="rounded-lg px-2 py-1 text-sm font-semibold text-gray-500 hover:text-gray-700"
                aria-label="Close modal"
              >
                ✕
              </button>
            </div>
            <div className="mt-5 flex justify-end">
              <button
                type="button"
                onClick={() => setIsStatusModalOpen(false)}
                className={`rounded-xl px-4 py-2 text-sm font-semibold text-white shadow-md transition-all duration-200 ${
                  submissionStatus === "success"
                    ? "bg-green-600 hover:bg-green-700"
                    : "bg-red-600 hover:bg-red-700"
                }`}
              >
                Okay
              </button>
            </div>
          </div>
        </div>
      )} */}
      <Helmet>
        <title>Book a Consultation | Free Discovery Call with Aleks</title>
        <meta
          name="description"
          content="Book your free 20-minute discovery call or consultation with Aleks, a registered nutritional therapist. Choose your preferred date and time for personalised nutrition guidance."
        />
        <meta
          name="keywords"
          content="book consultation, free discovery call, nutritional therapy consultation, online booking, health consultation"
        />
        <meta property="og:title" content="Book Your Free Discovery Call" />
        <meta
          property="og:description"
          content="Schedule your consultation with a registered nutritional therapist. Free 20-minute discovery call or paid in-depth consultations available."
        />
        <meta property="og:type" content="website" />
      </Helmet>
      <div className="container max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-12 md:pt-24 md:pb-16">
        {/* Page Header */}
        <div className="text-center mb-12 md:mb-16">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight mb-4">
            Pricing
          </h1>
          <p className="text-base sm:text-lg text-gray-100 max-w-2xl mx-auto">
            Choose the session that fits your goals, then book a time that works
            for you.
          </p>
          <div className="mt-8 flex justify-center">
            <a
              href="https://www.bookable.page/aleksandra"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center rounded-xl border-2 border-white bg-white px-6 py-3 text-sm font-semibold text-primary shadow-xl transition-all duration-300 hover:-translate-y-0.5 hover:bg-primary hover:text-white hover:border-primary"
            >
              Book your session now
            </a>
          </div>
          <div className="w-24 h-1 bg-gray-300 mx-auto rounded-full mt-6"></div>
        </div>

        {/* Pricing List */}
        <div className="max-w-6xl mx-auto mb-12 md:mb-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {pricingOptions.map((option) => (
              <div
                key={option.title}
                className={`bg-white/95 backdrop-blur-sm rounded-2xl shadow-lg border p-6 sm:p-7 transition-all duration-300 hover:shadow-xl hover:scale-[1.02] flex flex-col ${
                  option.highlight
                    ? "border-primary/40 ring-1 ring-primary/20"
                    : "border-white/20"
                }`}
              >
                <div className="flex items-center justify-between mb-4">
                  <h2 className="text-xl font-bold text-gray-900">
                    {option.title}
                  </h2>
                  {option.highlight ? (
                    <span className="inline-flex items-center gap-1 text-xs font-semibold text-primary bg-primary/10 px-3 py-1 rounded-full">
                      <Sparkles className="w-3.5 h-3.5" />
                      Popular
                    </span>
                  ) : null}
                </div>
                <div className="flex items-end gap-3 mb-4">
                  <span className="text-3xl font-bold text-primary">
                    {option.price}
                  </span>
                  <span className="text-sm text-gray-500">
                    {option.duration}
                  </span>
                </div>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-5 flex-grow">
                  {option.description}
                </p>
                <div className="flex items-center gap-2 text-sm text-gray-600 mt-auto">
                  <CheckCircle className="w-4 h-4 text-primary" />
                  Online or in-person
                </div>
              </div>
            ))}

            {/* Premium Card */}
          </div>
          <div className="sm:col-span-2 lg:col-span-2 lg:w-1/2 mx-auto mt-10 sm:w-full">
            <div className="relative rounded-2xl overflow-hidden transition-all duration-300 hover:shadow-2xl group">
              <div className="relative z-10 bg-[#EEF1F3] rounded-2xl p-7 sm:p-8 text-center shadow-lg">
                <div className="inline-flex items-end justify-end gap-2 bg-gradient-to-r from-primary to-primary text-white text-xs font-bold px-4 py-2 rounded-full mb-3 uppercase tracking-wider">
                  <Sparkles className="w-4 h-4" />
                  Exclusive
                </div>
                <h2 className="text-2xl sm:text-3xl font-bold text-left bg-gradient-to-r from-primary to-primary bg-clip-text text-transparent mb-2">
                  Meal prep service
                </h2>
                <p className="text-sm sm:text-base text-primary text-left mb-5 font-medium">
                  (initial consultation + cooking at your home for weekly meals)
                </p>
                <div className="text-2xl sm:text-3xl font-bold text-left text-primary mb-1">
                  £750{" "}
                  <span className="text-sm sm:text-base">(first week)</span>
                </div>
                <p className="text-sm sm:text-base text-primary text-left mb-4 font-semibold">
                  <span className="text-2xl sm:text-3x">£600</span> (for
                  subsequent weekly meal preps)
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Booking Form */}
        {/* <div
          ref={bookingSectionRef}
          className="max-w-5xl mx-auto scroll-mt-20 sm:scroll-mt-32"
          id="book-now"
        >
          <div className="bg-white/95 backdrop-blur-sm rounded-3xl shadow-2xl border border-white/20 p-8 sm:p-10 lg:p-12">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-8">
              <div>
                <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">
                  Book your session
                </h2>
                 <p className="text-sm sm:text-base text-gray-600">
                  Select a date to reveal available time slots.
                </p> 
              </div>
              <div className="flex items-center gap-2 text-sm text-primary font-semibold bg-primary/10 px-4 py-2 rounded-full">
                <Clock className="w-4 h-4" />
                Flexible scheduling
              </div>
            </div>

            {/* <form className="space-y-8" onSubmit={onSubmit} ref={formRef}>
              // Calendar Section - Always Visible 
              <div>
                <label className="block text-sm text-left font-semibold text-gray-700 mb-3">
                  Select a date
                </label>
                <div className="consultations-calendar">
                  <div className="consultations-calendar-header">
                    <button
                      type="button"
                      onClick={() =>
                        setViewMonth(
                          new Date(
                            viewMonth.getFullYear(),
                            viewMonth.getMonth() - 1,
                            1,
                          ),
                        )
                      }
                      className="consultations-calendar-nav"
                      aria-label="Previous month"
                    >
                      <ChevronLeft className="w-5 h-5" />
                    </button>
                    <p className="consultations-calendar-title">
                      {viewMonth.toLocaleDateString("en-GB", {
                        month: "long",
                        year: "numeric",
                      })}
                    </p>
                    <button
                      type="button"
                      onClick={() =>
                        setViewMonth(
                          new Date(
                            viewMonth.getFullYear(),
                            viewMonth.getMonth() + 1,
                            1,
                          ),
                        )
                      }
                      className="consultations-calendar-nav"
                      aria-label="Next month"
                    >
                      <ChevronRight className="w-5 h-5" />
                    </button>
                  </div>

                  <div className="consultations-calendar-weekdays">
                    {["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map(
                      (day) => (
                        <span key={day}>{day}</span>
                      ),
                    )}
                  </div>

                  <div className="consultations-calendar-grid">
                    {calendarDays.map((date) => {
                      const isCurrentMonth =
                        date.getMonth() === viewMonth.getMonth();
                      const isPast = date < today;
                      const dayOfWeek = date.getDay();
                      const isAllowedDay =
                        dayOfWeek === 3 || dayOfWeek === 4 || dayOfWeek === 5;
                      const isoDate = `${date.getFullYear()}-${String(
                        date.getMonth() + 1,
                      ).padStart(2, "0")}-${String(date.getDate()).padStart(
                        2,
                        "0",
                      )}`;
                      const isSelected = selectedDate === isoDate;
                      const isDisabled =
                        !isCurrentMonth || isPast || !isAllowedDay;

                      return (
                        <button
                          key={isoDate}
                          type="button"
                          disabled={isDisabled}
                          onClick={() => handleSelectDate(date)}
                          className={`consultations-calendar-day ${
                            isSelected ? "is-selected" : ""
                          } ${isDisabled ? "is-disabled" : ""}`}
                        >
                          {date.getDate()}
                        </button>
                      );
                    })}
                  </div>
                </div>
              </div>

              // Time Slots - Show after date selected 
              {selectedDate && (
                <div
                  ref={timeSlotsRef}
                  className="scroll-mt-16 sm:scroll-mt-10"
                >
                  <label className="block text-sm text-left font-semibold text-gray-700 mb-3">
                    Available time slots
                  </label>
                  <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
                    {timeSlots.map((slot) => (
                      <button
                        key={slot}
                        type="button"
                        onClick={() => setSelectedTime(slot)}
                        className={`rounded-xl border px-3 py-2 text-sm font-semibold transition-all duration-200 ${
                          selectedTime === slot
                            ? "bg-primary text-white border-primary shadow"
                            : "bg-white text-gray-700 border-gray-200 hover:border-primary/50 hover:text-primary"
                        }`}
                      >
                        {slot}
                      </button>
                    ))}
                  </div>
                </div>
              )}

              // Form Fields - Show after date and time selected 
              {selectedDate && selectedTime && (
                <div
                  ref={infoSectionRef}
                  className="space-y-5 scroll-mt-16 sm:scroll-mt-28"
                >
                  <div>
                    <label className="block text-sm text-left font-semibold text-gray-700 mb-2">
                      Full name
                    </label>
                    <input
                      type="text"
                      name="fullName"
                      value={fullName}
                      onChange={(e) => setFullName(e.target.value)}
                      className="w-full rounded-xl border border-gray-200 px-4 py-3 text-gray-900 focus:outline-none focus:ring-2 focus:ring-primary/50"
                      placeholder="Your name"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm text-left font-semibold text-gray-700 mb-2">
                      Email address
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="w-full rounded-xl border border-gray-200 px-4 py-3 text-gray-900 focus:outline-none focus:ring-2 focus:ring-primary/50"
                      placeholder="you@email.com"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm text-left font-semibold text-gray-700 mb-2">
                      Service
                    </label>
                    <div className="w-full rounded-xl border border-gray-200 px-4 py-3 text-gray-900 bg-gray-50">
                      Discovery Call
                    </div>
                    <input
                      type="hidden"
                      name="service"
                      value="Discovery Call"
                    />
                  </div>

                  <div className="rounded-2xl bg-primary/10 border border-primary/20 p-5">
                    <div className="flex items-center gap-3 mb-3">
                      <CheckCircle className="w-5 h-5 text-primary" />
                      <p className="text-sm font-semibold text-gray-800">
                        Your selection
                      </p>
                    </div>
                    <p className="text-sm text-gray-700">
                      Date:{" "}
                      <span className="font-semibold">
                        {formatDisplayDate(selectedDate)}
                      </span>
                    </p>
                    <p className="text-sm text-gray-700 mt-1">
                      Time:{" "}
                      <span className="font-semibold">{selectedTime}</span>
                    </p>
                  </div>
                  {submissionStatus && (
                    <div
                      className={`rounded-lg p-4 text-center font-semibold text-white ${
                        submissionStatus === "success"
                          ? "bg-green-500"
                          : "bg-red-500"
                      }`}
                    >
                      {submissionStatus === "success"
                        ? "✓ Booking request submitted successfully!"
                        : "✗ Something went wrong. Please try again."}
                    </div>
                  )}

                  <button
                    type="submit"
                    className="w-full bg-primary text-white font-semibold py-3 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300"
                  >
                    Request booking
                  </button>
                </div>
              )}
            </form> 
          </div>
        </div> */}
      </div>
    </div>
  );
}
